import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "../../../assets/ui/icons";

/* u1 breadcrumb. The shared Breadcrumb derives its trail from the pathname, which on /u1/search reads "u1 › search". This one takes explicit crumbs so the... */
export const Breadcrumb = ({
  items = [{ label: "Home", to: "/" }, { label: "Search Results" }],
}) => (
  <nav
    aria-label="Breadcrumb"
    className="w-full rounded-xl border border-[var(--line)] bg-[var(--bg)] px-4 py-3"
  >
    <ol className="flex items-center gap-2 flex-wrap list-none m-0 p-0">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <li key={item.label} className="flex items-center gap-2 min-w-0">
            {i > 0 && (
              <span className="text-[var(--muted-2)]">
                <ChevronRight />
              </span>
            )}
            {isLast || !item.to ? (
              <span
                aria-current={isLast ? "page" : undefined}
                className="text-[13px] font-semibold text-[var(--ink)] font-sans truncate"
              >
                {item.label}
              </span>
            ) : (
              <Link
                to={item.to}
                className="text-[13px] font-medium text-[var(--muted)] font-sans hover:text-[var(--ink)] transition-colors truncate"
              >
                {item.label}
              </Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumb;
